import React from 'react'
import HeaderFour from '../header/HeaderFour';
import BannerFive from '../elements/BannerFive';
import Portfolio from './Portfolio';
import AboutOne from '../elements/AboutOne';
import ServiceFIve from '../elements/ServiceFIve';
import WorkingProcess from '../elements/WorkingProcess';
import Blog from './Blog';
import Footer from '../elements/Footer';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';
import sal from 'sal.js';


function HomeFive() {
    React.useEffect(() => {
        sal({
          threshold: 1,
          once: true,
        });
    }, []);
  return (
    <div>
        
        <div className="index-Five">
            <HeaderFour/>
            <main>
              <BannerFive/>
              <AboutOne/>
              <ServiceFIve/>
              <Portfolio/>
              <WorkingProcess/>
              <Blog/>
              <Footer/>
            </main>
        </div>



    </div>
  )
}

export default HomeFive